<mat-card class="menu-container p-0 elevation fx-flex-100" cdkMenu>
  <div class="fx-column">
    <div class="p-16">
      <span class="text bold">{{ 'DOCUMENT.VERSIONS' | translate }}</span>
    </div>
    <mat-divider></mat-divider>
    <div class="options-container">
      <div class="fx-column">
        @for (version of options(); track version.ref) {
          <div
            class="fx-row align-items-center justify-content-between option p-16 clickable actionable"
            [class.selected]="isCurrentlySelectedVersion(version)"
            (click)="navigateTo(version)"
          >
            <div class="fx-column">
              <span class="text">
                {{ getLabel(version) }}
                <span
                  class="ps-2 small light"
                  *ngIf="isCurrentDocumentVersion(version.ref)">({{ "DOCUMENT.CURRENT_VERSION_LABEL" | translate }})
                </span>
              </span>
              <time [dateTime]="getDate(version.createdAt)" class="small">{{ getDate(version.createdAt) }}</time>
            </div>
            <mat-icon
              *ngIf="isCurrentlySelectedVersion(version)"
              class="main"
              fontSet="material-icons-outlined"
            >check</mat-icon>
          </div>
        }
      </div>
    </div>
  </div>
</mat-card>
